import React from 'react';
import { Typography } from 'antd';
import ReactMarkdown from 'react-markdown';
import { AnalysisResult, AnalysisStatus } from '../../../types';
import './markdown.css';

const { Title, Text } = Typography;

interface CpoEligibilityProps {
  results: AnalysisResult;
  status: AnalysisStatus;
}

const CpoEligibility: React.FC<CpoEligibilityProps> = ({ results, status }) => {
  const { cpo_eligibility } = results;

  if (status === 'error') {
    return <Text>There was an unexpected error with CPO eligibility, once the report is complete, please rerun the analysis.</Text>;
  } else if (status === 'skipped') {
    return <Text>CPO eligibility was skipped by the user.</Text>;
  }

  if (!cpo_eligibility) {
    return <Text>No CPO eligibility data available.</Text>;
  }

  const content = cpo_eligibility.cleaned_content;

  return (
    <div>
      {content ? (
        <div className="markdown-content">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      ) : (
        <Text type="secondary">Analysis in progress...</Text>
      )}
    </div>
  );
};

export default CpoEligibility;